<template>
  <div id="main-contrato-avance-real-view">
    <v-card
      flat>
      <v-card-text>
        <avance-real
          :id-contrato="$route.params.idContrato">
        </avance-real>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import avanceReal from '@/components/administracion/contratos/contrato/avancereal/Main.vue';

export default {
  name: 'MainContratoAvanceRealView',
  components: {
    avanceReal,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
